import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { QualificationSection } from './components/QualificationSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (!f.fbq) {
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    f.fbq('init', '2042623636583188');
    f.fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-[#0D0D0D] text-[#F5F0E8] overflow-x-hidden selection:bg-[#D4A853] selection:text-[#0D0D0D]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <QualificationSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <FAQSection data-id="element-6" />

      <Footer data-id="element-7" />
    </main>;
}